import React from 'react';
import Section from '../ui/Section';
import Heading from '../ui/Heading';
import img from '../../assets/exterior/vasudharinihomes_exterior_13.png'

const CompanyStory = () => {
  return (
    <Section className='py-8 sm:py-10 sm:px-5 lg:px-10'>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="bg-yellow-500 text-black font-bold py-1 px-3 rounded-full text-sm mb-4 inline-block">OUR STORY</span>
          <Heading level={2}>The Vasudharini Journey</Heading>
          
          <p className="text-gray-700 mb-4">
            Vasudharini was born out of a vision to address the increasing requirements of affordable housing 
            amidst a lack of supply in the market. The name "Vasudharini," meaning "bearer of earth," reflects 
            our understanding that housing is an earthly need that deserves the utmost care and attention.
          </p>
          
          <p className="text-gray-700 mb-4">
            Our journey in real estate has evolved over the years. We started as an agency, then transitioned 
            to consultancy, and our expertise in property marketing eventually paved the way for us to develop 
            and promote our own properties.
          </p>
          
          <p className="text-gray-700 mb-4">
            What sets Vasudharini apart is our commitment to delivering on our promises. We understand that 
            every builder has their pros and cons, but our core philosophy revolves around maintaining trust 
            with our customers by fulfilling what we commit to.
          </p>
          
          <div className="mt-8 border-l-4 border-yellow-500 pl-4 italic text-gray-600">
            "Vasudharini stands for developing and promoting affordable homes. Our home buyers' dreams and 
            budget value us more in developing each project."
          </div>
        </div>
        
        <div className="space-y-4">
          <img 
            src={img}
            alt="Vasudharini Journey" 
            className="w-full h-auto "
          />
        </div>
      </div>
    </Section>
  );
};

export default CompanyStory;